module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_simrishamn-47869c6f92bdf0bfc7b533bbab5c61e3.png";